import { PRODUCT_COLLECTION_PRICING_GET_REQUEST } from '../actionTypes/ProductCollectionPricingActionTypes';

const getProductCollectionPricing = (productCollection) => ({
    type: PRODUCT_COLLECTION_PRICING_GET_REQUEST,
    productCollection,
});

export default getProductCollectionPricing;
